import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import * as api from "./../../api/api";
import CopyrightIcon from "@material-ui/icons/Copyright";

//ICON
import FacebookIcon from "@material-ui/icons/Facebook";
import TwitterIcon from "@material-ui/icons/Twitter";
import LinkedInIcon from "@material-ui/icons/LinkedIn";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > * + *": {
      marginLeft: theme.spacing(2),
    },
  },
  icon: {
    display: "inline-flex",
    verticalAlign: "top",
    fontSize: "20px",
  },
}));

const initialData = {
  id: "",
  creaed_at: "",
  email_id: "",
  facebook: "",
  linkdin: "",
  name: "",
  twitter: "",
  logo: "",
  mobile_no: "",
  updated_at: "",
};

const isAuth = localStorage.getItem("isAuth") === "true";

export default function Links() {
  const classes = useStyles();
  const [company, setCompany] = useState(initialData);
  useEffect(() => {
    companyAPI();
  }, []);

  const companyAPI = async () => {
    try {
      const response = await api.company();
      setCompany(response[0]);
    } catch (e) {}
  };

  return (
    <>
      <div className=" mobileFooter">
        <ul
          className="flex justify-content-center py-2"
          style={{ color: "black" }}
        >
          <li>
            <Link to="/">
              <button className="border-0 bg-transparent text-white">
                Home
              </button>
            </Link>
          </li>

          <li>
            <Link to="/about-us">
              <button className="border-0 bg-transparent text-white">
                About 121five.com
              </button>
            </Link>
          </li>

          <li>
            <Link to="/search-news-and-features">
              <button className="border-0 bg-transparent text-white">
                Search News & Features
              </button>
            </Link>
          </li>

          <li>
            <Link to="/gallery">
              <button className="border-0 bg-transparent text-white">
                Photographer Galleries
              </button>
            </Link>
          </li>

          <li>
            <Link to="/contact-us">
              <button className="border-0 bg-transparent text-white">
                Contact Information
              </button>
            </Link>
          </li>

          <li>
            <a href="https://aerovents.com/body.shtml" target="_blank">
              <button className="border-0 bg-transparent text-white">
                AeroVents.com Calendar
              </button>
            </a>
          </li>

          <li>
            {isAuth ? (
              <Link to="/dashboard">
                <button className="border-0 bg-transparent text-white">
                  Sponsor Portal
                </button>
              </Link>
            ) : (
              <Link to="/login">
                <button className="border-0 bg-transparent text-white">
                  Sponsor Portal
                </button>
              </Link>
            )}
          </li>
        </ul>
      </div>
      <section className="copyright py-3">
        <div className="container desktopFooter">
          <ul className="flex justify-content-center pb-2">
            <li>
              <Link to="/">
                <button className="border-0 bg-transparent text-white">
                  Home
                </button>
              </Link>
            </li>
            <span>|</span>
            <li>
              <Link to="/about-us">
                <button className="border-0 bg-transparent text-white">
                  About 121five.com
                </button>
              </Link>
            </li>
            <span>|</span>
            <li>
              <Link to="/search-news-and-features">
                <button className="border-0 bg-transparent text-white">
                  Search News & Features
                </button>
              </Link>
            </li>
            <span>|</span>
            <li>
              <Link to="/gallery">
                <button className="border-0 bg-transparent text-white">
                  Photographer Galleries
                </button>
              </Link>
            </li>
            <span>|</span>
            <li>
              <Link to="/contact-us">
                <button className="border-0 bg-transparent text-white">
                  Contact Information
                </button>
              </Link>
            </li>
            <span>|</span>
            <li>
              <a href="https://aerovents.com/body.shtml" target="_blank">
                <button className="border-0 bg-transparent text-white">
                  AeroVents.com Calendar
                </button>
              </a>
            </li>
            <span>|</span>
            <li>
              {isAuth ? (
                <Link to="/dashboard">
                  <button className="border-0 bg-transparent text-white">
                    Sponsor Portal
                  </button>
                </Link>
              ) : (
                <Link to="/login">
                  <button className="border-0 bg-transparent text-white">
                    Sponsor Portal
                  </button>
                </Link>
              )}
            </li>
          </ul>
        </div>
        <div className="container">
          <div className="row justify-content-lg-between justify-content-center align-items-center">
            <div className="col-lg-4 col-md-12 text-lg-left text-center">
              <p>
                Copyright
                <sup>
                  <CopyrightIcon style={{ fontSize: "12px" }} />{" "}
                </sup>
                {company.name}. All rights reserved.{" "}
              </p>
            </div>
            <div className="col-lg-3 col-md-12 text-lg-left text-center">
              <div className="social d-flex justify-content-center">
                <ul>
                  <li>
                    <a
                      href={company.facebook}
                      target="_blank"
                      rel="noreferrer"
                      className="social-icon"
                    >
                      <FacebookIcon className={classes.icon} />
                    </a>
                  </li>
                  <li>
                    <a
                      href={company.twitter}
                      target="_blank"
                      rel="noreferrer"
                      className="social-icon"
                    >
                      <TwitterIcon className={classes.icon} />
                    </a>
                  </li>
                  <li>
                    <a
                      href={company.linkdin}
                      target="_blank"
                      rel="noreferrer"
                      className="social-icon"
                    >
                      <LinkedInIcon
                        className={classes.icon}
                        style={{ marginLeft: "-12px" }}
                      />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-5 col-md-12 text-lg-right text-center ">
              <div className=" d-flex justify-content-center">
                <ul>
                  <li>
                    <Link to="/terms-of-use">
                      <button className="border-0 bg-transparent text-white">
                        Terms of Use
                      </button>
                    </Link>
                  </li>
                  <span>|</span>
                  <li>
                    <Link to="/privacy-policy">
                      <button className="border-0 bg-transparent text-white">
                        Privacy Policy
                      </button>
                    </Link>
                  </li>
                  <span>|</span>
                  <li>
                    <Link to="/contact-us">
                      <button className="border-0 bg-transparent text-white">
                        Contact
                      </button>
                    </Link>
                 </li>
          
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
